import { useEndAppointmentDeparture } from '../../../entities/appointment'
import { getStartWorkErrorMessage } from '../model/getStartWorkErrorMessage'
import { EndDepartureModalView } from './EndDepartureModalView'

type Props = {
  show: boolean
  setShow: (show: boolean) => void
  appointmentId: number
  workOrderId?: string
  /** ISO `schedule.actualEndsAt` — the recorded work end the departure is measured from. */
  actualEndsAt: string | null
  onSuccess: () => void
}

export const EndAppointmentDepartureModal = ({
  show,
  setShow,
  appointmentId,
  workOrderId,
  actualEndsAt,
  onSuccess,
}: Props) => {
  const endDeparture = useEndAppointmentDeparture()

  return (
    <EndDepartureModalView
      show={show}
      setShow={setShow}
      actualEndsAt={actualEndsAt}
      isPending={endDeparture.isPending}
      errorMessage={endDeparture.isError ? getStartWorkErrorMessage(endDeparture.error) : null}
      onOpen={() => endDeparture.reset()}
      onSubmit={(dto) => endDeparture.mutate({ id: appointmentId, workOrderId, dto }, { onSuccess })}
    />
  )
}
